export const scrollToElementFnc = (el: HTMLElement | string, margin = 0, elementToScroll: Window | string = window) => {
    const element: HTMLElement = typeof el === 'string' ? document.getElementById(<string>el) : <HTMLElement>el
    const scrollElement =
        typeof elementToScroll === 'string' ? document.getElementById(<string>elementToScroll) : window
    scrollElement.scrollTo({
        top: element.offsetTop - margin,
        behavior: 'smooth',
    })
}
